import React from 'react';

const HomeMessage = () => {
    return (
        <div className='animate__animated animate__fadeInLeft animate__slow homeMessage
         row align-items-center justify-content-center'>
            <div className='col-md-12 d-flex align-items-center'>
                <div className='text-left px-1'>
                    <h1 className='text-uppercase font-weight-bolder text-left text-warning' >The AFBR</h1>
                    <p style={{ marginBottom: '1px', fontSize: '1.3rem' }} className='
            font-weight-bold'>Making the bully community well respected.</p>
                    <p style={{ marginBottom: '0px', fontSize: '1.3rem' }} 
                    className='font-weight-bold'>Africa's Premier Bully Registry  connecting bully breeds
                      across Africa and around the globe.</p>
                </div>

            </div>

        </div>

    )
}



export default HomeMessage;